module.exports = __webpack_public_path__ + "img/route.9c263c52.svg";